/* src/app/shared/components/image-rotator/image-rotator.component.scss */
.flex-center,
.image-rotator .previous,
.image-rotator .next {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.image-rotator {
  font-size: 1rem;
  position: relative;
}
.image-rotator ul.image-items {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow: hidden;
  width: auto;
  max-height: 15.625rem;
  height: 15.625rem;
}
.image-rotator ul.image-items li.image-item {
  flex: 0;
  width: 100%;
  height: 100%;
  transition: flex 0.75s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.image-rotator ul.image-items li.image-item.current {
  flex: 1;
}
.image-rotator ul.image-items li.image-item a {
  display: block;
  width: 100%;
  height: 100%;
}
.image-rotator ul.image-items li.image-item a picture {
  display: block;
  width: 100%;
  height: 100%;
}
.image-rotator ul.image-items li.image-item a picture img {
  object-fit: cover;
  width: auto;
  height: 100%;
}
@media screen and (min-width: 64rem) {
  .image-rotator ul.image-items li.image-item a picture img {
    min-width: 1150px;
  }
}
.image-rotator .previous,
.image-rotator .next {
  position: absolute;
  top: 0;
  width: 2.5rem;
  height: 100%;
}
.image-rotator .previous.disabled a,
.image-rotator .previous[disabled] a,
.image-rotator .next.disabled a,
.image-rotator .next[disabled] a {
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
}
.image-rotator .previous a,
.image-rotator .next a {
  color: white;
}
.image-rotator .previous a:hover,
.image-rotator .previous a:active,
.image-rotator .previous a:visited,
.image-rotator .next a:hover,
.image-rotator .next a:active,
.image-rotator .next a:visited {
  text-decoration: none;
}
.image-rotator .previous a .mat-icon,
.image-rotator .next a .mat-icon {
  height: auto;
  width: auto;
  font-size: 2.5rem;
}
.image-rotator .previous {
  left: 0;
}
.image-rotator .next {
  right: 0;
}
.image-rotator ul.image-counters {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3.125rem;
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  overflow: hidden;
}
.image-rotator ul.image-counters li.image-counter {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  width: 0.75rem;
  height: 0.75rem;
  margin: 0 0.5rem;
  cursor: pointer;
}
.image-rotator ul.image-counters li.image-counter.current {
  background-color: rgb(255, 255, 255);
}
.image-rotator ul.image-counters li.image-counter:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
/*# sourceMappingURL=image-rotator.component.css.map */
